export * from './page-quick-action.component';
